.dayTxt {
  color: var(--brand-color);
  display: flex;
  flex-direction: column;
  font-family: var(--dayIcn-font);
  height: 50px;
  justify-content: center;
  text-align: center;
  width: 50px;
  font-size: var(--dayicn-font-size);
}
